// ##############################
// // // Sidebar styles
// #############################

import {
  drawerWidth,
  transition,
  boxShadow,
  defaultFont,
  primaryColor,
  primaryBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
    sidebarColor
} from "../material-dashboard-react.jsx";

const sidebarStyle = theme => ({
  drawerPaper: {
    border: "none",
    position: "fixed",
    top: "0",
    bottom: "0",
    left: "0",
    zIndex: "1",
      backgroundColor: sidebarColor,
    // overflow: 'auto',
    // ...boxShadow,
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    width: drawerWidth,
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      position: "fixed",
      height: "100%"
    },
    // [theme.breakpoints.down("sm")]: {
    //   width: drawerWidth,
    //   ...boxShadow,
    //   position: "fixed",
    //   display: "block",
    //   top: "0",
    //   height: "100vh",
    //   right: "0",
    //   left: "auto",
    //   zIndex: "1032",
    //   visibility: "visible",
    //   overflowY: "visible",
    //   borderTop: "none",
    //   textAlign: "left",
    //   paddingRight: "0px",
    //   paddingLeft: "0",
    //   transform: `translate3d(${drawerWidth}px, 0, 0)`,
    //   ...transition
    // }
  },
  logo: {
    position: "relative",
    padding: "30px 25px",
    zIndex: "4",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "0",
      height: "1px",
      right: "15px",
      width: "calc(100% - 30px)",
      backgroundColor: "rgba(180, 180, 180, 0.3)"
    }
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerOpenMob: {
    width: "100vw",
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    overflowX: 'hidden',
    // width: '50px',
    // [theme.breakpoints.up('xs')]: {
      width: '0px',
    // // display:'none',
    // },
    [theme.breakpoints.up('sm')]: {
      width: '0px',
    },
  },
  logoLink: {
    ...defaultFont,
    textTransform: "uppercase",
    padding: "5px 0",
    display: "block",
    fontSize: "18px",
    textAlign: "left",
    fontWeight: "400",
    lineHeight: "30px",
    textDecoration: "none",
    backgroundColor: "transparent",
    "&,&:hover": {
      color: "#FFFFFF"
    }
  },
  logoImage: {
    // width: "30px",
    color: '#2896E9',
    fontSize: '1.4rem',
    fontWeight: '600',
    display: "inline-block",
    maxHeight: "30px",
    marginLeft: "25px",
    marginRight: "15px",
    textAlign: 'center'
  },
  logoImageMobile: {
    // width: "30px",
    color: '#2896E9',
    fontSize: '1.4rem',
    fontWeight: '600',
    display: "flex",
    justifyContent:"space-between",
    maxHeight: "30px",
    marginLeft: "25px",
    // marginRight: "15px",
    textAlign: 'center'
  },
  img: {
    left: "7px",
    height: "42px",
    top: "26px",
    position: "absolute",
    verticalAlign: "middle",
    border: "0",
  },
    sidebarBackgroundColor: {
    backgroundColor: sidebarColor
    },
  newText: {
    marginLeft: '10px'
  },
  notext:{
    marginTop:"30px",
    marginLeft: '20px',
    fontWeight:"500"
  },
  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    "&:after": {
      position: "absolute",
      zIndex: "3",
      width: "100%",
      height: "100%",
      content: '""',
      display: "block",
      background: "#000",
      opacity: ".8",
    }
  },
  list: {
    marginTop: "20px",
    paddingLeft: "0",
    paddingTop: "0",
    paddingBottom: "0",
    marginBottom: "0",
    listStyle: "none"
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    width: "100%",
  },
  itemLink: {
    width: '100%',
    minHeight: "34px",
    boxSizing: "border-box",
    transition: "all 300ms linear",
    margin: "5px 0px 0",
    // borderRadius: "3px",
    position: "relative",
    display: "flex",
    padding: "5px 15px",
    alignItems: 'center',
    backgroundColor: "transparent",
    ...defaultFont
  },
  sidebarIcon: {
    fontSize: '20px',
    flexShrink: 0,
  },
  nested: {
    paddingLeft: theme.spacing(3),
  },
  itemIcon: {
    width: "26px",
    minWidth: "26px",
    height: "30px",
    flex: "0 0 26px",
    flexShrink: 0,
    float: "left",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: 'rgb(173, 180, 210)'
  },
  itemText: {
    ...defaultFont,
    margin: "0",
    lineHeight: "30px",
    fontSize: "12px !important",
    fontWeight: '600',
    color: "#919BB0",
    fontFamily: 'Montserrat, sans-serif',
    marginBottom: '0',
    minWidth: 0,
    flex: "1 1 auto",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  whiteFont: {
    color: "#FFFFFF"
  },
  countBadge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    flexShrink: 0,
    marginLeft: "8px",
    height: "20px",
    minWidth: "20px",
    padding: "0 5px",
    borderRadius: "999px",
    backgroundColor: dangerColor,
    color: "#FFFFFF",
    fontSize: "11px",
    fontWeight: "700",
    lineHeight: "1",
  },
  purple: {
    backgroundColor: primaryColor,
    ...primaryBoxShadow,
    "&:hover": {
      backgroundColor: primaryColor,
      ...primaryBoxShadow
    }
  },
  blue: {
    backgroundImage: "linear-gradient(265deg , #7467F0,#2896E9) ",
    // backgroundColor: theme.palette.primary.main,
    // boxShadow:
    //   "0 12px 20px -10px rgba(0,188,212,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(0,188,212,.2)",
    "&:hover": {
      backgroundImage: "linear-gradient(265deg , #7467F0,#2896E9) ",
      // backgroundColor: theme.palette.primary.main,
      // boxShadow:
      //   "0 12px 20px -10px rgba(0,188,212,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(0,188,212,.2)"
    }
  },
  green: {
    backgroundColor: successColor,
    boxShadow:
      "0 12px 20px -10px rgba(76,175,80,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(76,175,80,.2)",
    "&:hover": {
      backgroundColor: successColor,
      boxShadow:
        "0 12px 20px -10px rgba(76,175,80,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(76,175,80,.2)"
    }
  },
  orange: {
    backgroundColor: warningColor,
    boxShadow:
      "0 12px 20px -10px rgba(255,152,0,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(255,152,0,.2)",
    "&:hover": {
      backgroundColor: warningColor,
      boxShadow:
        "0 12px 20px -10px rgba(255,152,0,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(255,152,0,.2)"
    }
  },
  red: {
    backgroundColor: dangerColor,
    boxShadow:
      "0 12px 20px -10px rgba(244,67,54,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(244,67,54,.2)",
    "&:hover": {
      backgroundColor: dangerColor,
      boxShadow:
        "0 12px 20px -10px rgba(244,67,54,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(244,67,54,.2)"
    }
  },
  sidebarWrapper: {
    position: "relative",
    height: "calc(100vh - 75px)",
    overflow: "auto",
    width: drawerWidth,
    zIndex: "4",
    overflowScrolling: 'touch'
  },
  sidebarWrapperMobile:{
    position: "relative",
    height: "calc(100vh - 75px)",
    overflow: "auto",
    width: "100vw",
    zIndex: "4",
    overflowScrolling: 'touch'
  },
  filterWrap:{
    padding:"0 20px",
    width:"calc(100vw- 40px)"
  }
});

export default sidebarStyle;
